import type {
  Maybe,
  MediaEdge,
  MediaImage,
  MetafieldReference,
} from '@shopify/hydrogen-react/storefront-api-types'

/**
 * Shopify `Product` `MediaImage` typeguard.
 *
 */
export const isMediaImage = (
  media: MediaEdge['node'] | Maybe<MetafieldReference>,
): media is MediaImage => {
  return media?.__typename === 'MediaImage'
}
